// public/js/features/settings/webhooks-api.js
// Thin wrappers around the outbound-webhook management endpoints. The signing
// secret is returned only on create + rotate. See docs/api-access.md.

async function jsonOrThrow(res) {
  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try { msg = (await res.json()).error || msg; } catch {}
    throw new Error(msg);
  }
  return res.json();
}

const q = (tenantId) => (tenantId ? `?tenantId=${encodeURIComponent(tenantId)}` : '');

export async function listWebhooks(tenantId) {
  return jsonOrThrow(await window.authenticatedFetch(`api/v1/webhooks${q(tenantId)}`));
}

export async function createWebhook({ url, events, tenantId }) {
  return jsonOrThrow(await window.authenticatedFetch('api/v1/webhooks', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ url, events, tenantId }),
  }));
}

export async function updateWebhook(id, patch, tenantId) {
  return jsonOrThrow(await window.authenticatedFetch(`api/v1/webhooks/${encodeURIComponent(id)}${q(tenantId)}`, {
    method: 'PATCH', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(patch),
  }));
}

export async function deleteWebhook(id, tenantId) {
  return jsonOrThrow(await window.authenticatedFetch(`api/v1/webhooks/${encodeURIComponent(id)}${q(tenantId)}`, { method: 'DELETE' }));
}

export async function testWebhook(id, tenantId) {
  return jsonOrThrow(await window.authenticatedFetch(`api/v1/webhooks/${encodeURIComponent(id)}/test${q(tenantId)}`, { method: 'POST' }));
}
